<template>
  <div class="app-container">
    <list ref="list" @setDetails="setDetails">
      <template slot="toolbar-right" v-if="$permission.canWrite()">
        <el-button size="mini" type="primary" @click="create" icon="el-icon-plus">添加</el-button>
        <el-button size="mini" class="filter-item" type="danger" @click="delRows">删除</el-button>
      </template>
      <template slot="column" v-if="$permission.canWrite()">
        <!-- <el-table-column label="操作" fixed="right" align="center" width="80">
          <template slot-scope="{ row }">
            <el-button
          size="mini"
          type="primary"
          @click="create"
          icon="el-icon-plus"
          >中止</el-button
        >
          </template>
        </el-table-column> -->
        <el-table-column label="操作" fixed="right" align="center" width="140">
          <template slot-scope="{ row }">
            <!-- <el-button type="text" v-if="row.Status==2" @click="editById(row.OrderId)">查看</el-button> -->
            <el-button type="text" v-if="row.Status != 2" @click="editById(row.DocId)">编辑</el-button>
            <el-button type="text" @click="check(row)">审核</el-button>
            <!-- <el-button type="text" v-if="row.Status!=2" @click="delRows(row.OrderId)">删除</el-button> -->
          </template>
        </el-table-column>
      </template>
    </list>
    <div class="list-head" style="margin-top: 10px">
      <span>订单详情</span>
      <div class="list-detail">
        <span>订单号：{{ row.DocNo || '-' }}</span>
        <span>业务员：{{ row.ClerkName || '-' }}</span>
        <span>备注：{{ row.Remark || '-' }}</span>
        <span>订单金额：{{ Math.floor(row.Amount * 100) / 100 || '-' }}</span>
      </div>
    </div>
    <div class="thinScroll" :style="'px;overflow-y:auto;width:100%'">
      <el-row class="mb0">
        <el-table :data="Details" size="mini" border style="width: 100%">
          <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
          <el-table-column prop="BarCode" label="条码" align="center" min-width="100" />
          <el-table-column prop="GoodsName" label="商品名称" align="center" />
          <el-table-column prop="Model" label="规格型号" align="center" />
          <el-table-column prop="UnitName" label="单位" align="center" />
          <el-table-column  prop="WarehouseName" label="仓库" align="center" />
          <el-table-column prop="Offer" label="报价" align="center">
            <template slot-scope="{ row }">
              {{ $commonJs.toThousands(row.Offer) }}
            </template>
          </el-table-column>
          <el-table-column prop="Discount" label="折扣%" width="90" align="center" />
          <el-table-column prop="NoTaxPrice" v-if="DisposeTax == 1" label="无税单价" width="90" align="center">
            <template slot-scope="{ row }">
              {{ $commonJs.toThousands(row.NoTaxPrice) }}
            </template>
          </el-table-column>
          <el-table-column prop="TaxRate" v-if="DisposeTax == 1" label="税率/%" width="90" align="center" />
          <el-table-column prop="Price" label="单价" width="90" align="center">
            <template slot-scope="{ row }">
              {{ $commonJs.toThousands(row.Price) }}
            </template>
          </el-table-column>
          <el-table-column prop="Quantity" label="数量" width="90" align="center" />
          <el-table-column prop="TaxAmount" v-if="DisposeTax == 1" label="税额" width="90" align="center">
            <template slot-scope="{ row }">
              {{ $commonJs.toThousands(row.TaxAmount) }}
            </template>
          </el-table-column>
          <el-table-column prop="Amount" label="含税金额" width="90" align="center">
            <template slot-scope="{ row }">
              {{ $commonJs.toThousands(row.Amount) }}
            </template>
          </el-table-column>
          <el-table-column prop="NoTaxAmount" label="不含税金额" width="90" align="center">
            <template slot-scope="{ row }">
              {{ $commonJs.toThousands(row.NoTaxAmount) }}
            </template>
          </el-table-column>
          <el-table-column prop="num" label="包装数量" width="90" align="center" />
        </el-table>
      </el-row>
    </div>
    <edit-dialog ref="editDialog" @close-saved="reload" :DisposeTax="DisposeTax" />
  </div>
</template>
<script>
import curdMixins from '@/mixins/curd'
import list from '@/components/purchase/business/return/list'
import editDialog from '@/components/purchase/business/return/editDialog'

export default {
  name: 'comment',
  mixins: [curdMixins],
  components: {
    list,
    editDialog
  },
  data() {
    return {
      api: require('@/api/sale/sales').default,
      optApi: require('@/api/sy/opt').default,
      wareApi: require("@/api/ba/warehouse").default,
      Details: [],
      row: {},
      DisposeTax: '',
      wareList: [],
    }
  },
  mounted() {
    this.optApi.list({ Code: 'PURCHASE' }).then(res => {
      res.Data.forEach(e => {
        if (e.OptText == 'DisposeTax') {
          this.DisposeTax = e.OptValue
        }
      })
    })
     this.wareApi.list({ PageIndex: 1, PageSize: 100 }).then(res => {
      this.wareList = res.Data
      sessionStorage.setItem("ware",JSON.stringify(res.Data))
    })
  },
  methods: {
    setDetails(list, row) {
      this.Details = list
      this.row = row
    },
    // details(id) {
    //   this.$refs.editDialog.openDetailsById(id)
    // },
    check(row) {
      sessionStorage.setItem('check', '1')
      this.editById(row.DocId)
    },
    delRows() {
      let rows = this.$refs.list.getCheckedRows()
      if (rows.length == 0) {
        this.$message.warning('请选择要删除的数据')
        return
      }
      this.$confirm('确认删除所选的数据吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          let ids = rows.map(item => {
            return item.DocId
          })
          this.$refs.list.delRange(ids)
        })
        .catch(() => {})
    }
  }
}
</script>
